export const messages = {
  en: {
    addRoomRepair: {
      title: 'Phone Repair',
      repairType: 'Repair Type',
      repairTypePlaceholder: 'Required, please select repair type',
      repairName: 'Repairer',
      repairNamePlaceholder: 'Required, please fill in the repairer',
      tel: 'Contact',
      telPlaceholder: 'Required, please fill in contact information',
      appointmentTime: 'Appointment Time',
      appointmentTimePlaceholder: 'Required, please fill in appointment time',
      context: 'Repair Content',
      contextPlaceholder: 'Required, please fill in repair content',
      back: 'Back',
      submit: 'Submit',
      submitSuccess: 'Submitted successfully',
      submitError: 'Submission failed'
    }
  },
  zh: {
    addRoomRepair: {
      title: '电话报修',
      repairType: '报修类型',
      repairTypePlaceholder: '必填，请选择报修类型',
      repairName: '报修人',
      repairNamePlaceholder: '必填，请填写报修人',
      tel: '联系方式',
      telPlaceholder: '必填，请填写联系方式',
      appointmentTime: '预约时间',
      appointmentTimePlaceholder: '必填，请填写预约时间',
      context: '报修内容',
      contextPlaceholder: '必填，请填写报修内容',
      back: '返回',
      submit: '提交',
      submitSuccess: '提交成功',
      submitError: '提交失败'
    }
  }
}